import { useState, useEffect } from 'react';
export type ViewportType = 'mobile' | 'desktop';

export const useViewport = () => {
	const breakpoint = 840;
	const [viewport, setViewport] = useState<ViewportType | undefined>(undefined);

	useEffect(() => {
		setViewport(window.innerWidth < breakpoint ? 'mobile' : 'desktop');
		const handleWindowResize = () => setViewport(window.innerWidth < breakpoint ? 'mobile' : 'desktop');
		window.addEventListener('resize', handleWindowResize);
		return () => window.removeEventListener('resize', handleWindowResize);
	}, []);

	// Return the width so we can use it in our components
	return { viewport };
};
